module.exports = __webpack_public_path__ + "img/img14.41da7b51.svg";